import { useParams } from 'react-router-dom';
import { ComparisonPage } from '@/components/compare/comparison-page';
import { ComparePageV2, COMPARE_V2_PAGES } from '@/routes/compare/compare-v2-page';
import { ALL_COMPETITORS } from '@/routes/compare/data';
import { NotFoundPage } from '@/routes/not-found';

/**
 * Dynamic comparison page wrapper for all /compare/:slug routes. The nine indexed comparisons use the v2
 * template (copy from seo-agent/plans/compare-v2); the other pages keep the older layout and are noindex.
 */
export function ComparisonPageWrapper() {
  const { slug } = useParams<{ slug: string }>();
  const v2 = COMPARE_V2_PAGES.find((p) => p.url === `/compare/${slug}`);
  if (v2) return <ComparePageV2 page={v2} />;

  const data = ALL_COMPETITORS.find((c) => c.slug === slug);
  if (!data) {
    return <NotFoundPage />;
  }

  return <ComparisonPage data={data} />;
}
